// src/config/config.js
const API_BASE_URL = "https://winscore-api.hayllis.com";
// const API_BASE_URL = "http://localhost:9500";

// const API_BASE_URL = "https://backendwinscore-production.up.railway.app";
// const API_BASE_URL = "https://winmaster.perufedup.com";

// const API_BASE_URL = "http://192.168.18.38:9500";
// const API_BASE_URL = "http://10.61.242.80:9500";
// const API_BASE_URL = "http://192.168.68.150:9500";
export default API_BASE_URL;